import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import { parse, stringify } from "query-string";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { getErrorValueResponse } from "../../common/error/Error";

import loadingGreen from "../../images/loading_gray.gif";
import { FILE_FORMATS, HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { USER_ROUTES } from "../../utils/routeConstants";
import { uploadFileToS3 } from "../../utils/s3Upload";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import FileUploadInput from "../FileUploadInput/FileUploadInput";
import { Container, MainButton } from "./FileUploadImporterCreditStyles";

function FileUploadImporterCredit(props) {
  let {
    toggleModal,
    payerRucOption,
    closeModal,
    dateUrlQuotationQuoted,
    quotation_ids,
    clearShoppingCar,
  } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showConfirmationModal, updateShowConfirmationModal] = useState(false);
  const [messageError, updateMessageError] = useState("");
  const onFileChange = (files) => {
    setSelectedFiles(files);
  };

  const [, setErrorCode] = useState(false);
  const [typeErrorCode, setTypeErrorCode] = useState("");
  const saveInvoices = useAsyncExecutor(
    async (params: any) => {
      const { payerRucOption, selectedFiles, quotation_ids } = params;
      const files = await uploadFileToS3(
        payerRucOption === "consignee"
          ? "consignee-credit-authorization"
          : "cargo-agent-credit-authorization",
        selectedFiles,
        "autorizacion_uso_linea_credito_"
      );
      const body = {
        quotation_ids,
        payment_type_option: "credit",
        credit_payment_detail: {
          payer_ruc_option: payerRucOption,
          credit_auth_doc: files[0],
        },
      };
      return networkBackendRequest(
        `/invoices/credit/`,
        HTTP_METHODS.POST,
        null,
        body
      ).then((response) => response.json());
    },
    {
      onSuccess: () => {
        getQuotationQuotedCredit.execute({ from_date: dateUrlQuotationQuoted });
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        clearShoppingCar();
        updateMessageError(errorMessage);
        toggleConfirmationModal();
        setErrorCode(
          error.error_code === "SAP004" || error.error_code === "VOL014"
            ? true
            : false
        );
        setTypeErrorCode(error.error_code);
      },
    }
  );
  const [redirectPage, setRedirectPage] = useState(0);
  const getQuotationQuotedCredit: any = useAsyncExecutor2(
    (params: any) => {
      return networkBackendRequest(`/quotations/quoted/`, HTTP_METHODS.GET, {
        from_date: params.from_date,
      }).then((resp) => resp.json());
    },
    {
      onSuccess: (data, params) => {
        const count = data.count;
        setRedirectPage(count);
        toggleConfirmationModal();
        setSelectedFiles([]);
      },
      onError: () => {
        setRedirectPage(1);
        toggleConfirmationModal();
        setSelectedFiles([]);
      },
    }
  );

  const toggleConfirmationModal = () => {
    updateShowConfirmationModal(!showConfirmationModal);
  };
  const history = useHistory();

  const parsedParams = { ...parse(window.location.search), page: 1 };
  const stringifiedParams = stringify(parsedParams);
  const pathname = history.location.pathname;
  return showConfirmationModal ? (
    !messageError ? (
      <ConfirmationModal
        title={
          selectedFiles.length > 1
            ? "Documentos subidos con éxito"
            : "Documento subido con éxito"
        }
        message={
          (selectedFiles.length > 1
            ? "La carga de los documentos ha sido exitosa."
            : "La carga del documento ha sido exitosa.") +
          " Haga clic en entendido o cierre el diálogo para continuar."
        }
        toggleModal={() => {
          if (redirectPage > 0) {
            toggleConfirmationModal();
            closeModal();
            history.push(`${pathname}?${stringifiedParams}`);
          } else {
            toggleConfirmationModal();
            closeModal();
            history.push(USER_ROUTES.PAYMENT_VALIDATION_STATUS.path);
          }
        }}
        onAccept={() => {
          if (redirectPage > 0) {
            toggleConfirmationModal();
            closeModal();
            history.push(`${pathname}?${stringifiedParams}`);
          } else {
            toggleConfirmationModal();
            closeModal();
            history.push(USER_ROUTES.PAYMENT_VALIDATION_STATUS.path);
          }
        }}
      />
    ) : (
      <ConfirmationModal
        message={messageError}
        onAccept={() => {
          updateShowConfirmationModal(false);
          toggleModal(true);
        }}
        title={`${
          typeErrorCode === "SAP004" ? "Crédito insuficiente" : "Atención"
        }`}
        toggleModal={() => {
          updateShowConfirmationModal(false);
          toggleModal(true);
        }}
      />
    )
  ) : (
    <Container>
      {payerRucOption === "consignee" ? (
        <h1>Adjuntar documento de CRÉDITO DEL IMPORTADOR</h1>
      ) : (
        <h1 style={{ textAlign: "center" }}>
          Adjuntar documento de CRÉDITO DEL AGENTE DE CARGA
        </h1>
      )}
      <FileUploadInput
        maxFiles={1}
        onValueChange={onFileChange}
        value={selectedFiles}
        formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
        disabled={saveInvoices.isLoading}
      />
      <MainButton
        disabled={
          selectedFiles.length === 0 ||
          saveInvoices.isLoading ||
          getQuotationQuotedCredit.isLoading ||
          quotation_ids.length < 1
        }
        onClick={() => {
          saveInvoices.execute({
            payerRucOption: payerRucOption,
            selectedFiles: selectedFiles,
            quotation_ids,
          });
        }}
      >
        {(saveInvoices.isLoading || getQuotationQuotedCredit.isLoading) && (
          <img src={loadingGreen} className="icon" alt="Processing request" />
        )}
        Enviar Documento
      </MainButton>
    </Container>
  );
}
export default FileUploadImporterCredit;
